<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>资产损失税前扣除及纳税调整明细表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" tabletype="2024033109">
        <thead>
          <tr>
            <th class="title01" rowspan="2" style="width: 50px">行次</th>
            <th class="title01" rowspan="2" style="width: 290px">项目</th>
            <th class="title01">资产损失直接计入本年损益金额</th>
            <th class="title01">资产损失准备金核销金额</th>
            <th class="title01">资产处置收入</th>
            <th class="title01">赔偿收入</th>
            <th class="title01">资产计税基础</th>
            <th class="title01">资产损失的税收金额</th>
            <th class="title01">纳税调整金额</th>
          </tr>
          <tr>
            <th class="title01">1</th>
            <th class="title01">2</th>
            <th class="title01">3</th>
            <th class="title01">4</th>
            <th class="title01">5</th>
            <th class="title01">6(5-3-4)</th>
            <th class="title01">7</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="title01">1</td>
            <td class="td_l title01">一、现金及银行存款损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v1x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v1x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v1x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">2</td>
            <td class="td_l title01">二、应收及预付款项坏账损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v2x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v2x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">3</td>
            <td class="td_l title01" style="padding-left: 28px">其中：逾期三年以上的应收款项损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v3x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v3x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v3x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v3x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">4</td>
            <td class="td_l title01" style="padding-left: 42px">逾期一年以上的小额应收款项损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v4x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v4x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v4x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v4x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">5</td>
            <td class="td_l title01">三、存货损失</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v5x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2"><el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v5x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v5x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6">
              <!-- 考题 -->
              <taxQue :data="data.v5x6" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v5x6.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d7">{{ parseFloatNum(data.v5x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">6</td>
            <td class="td_l title01" style="padding-left: 28px">其中：存货盘亏、报废、损毁、变质或被盗损失</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v6x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2"><el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v6x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v6x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6">
              <!-- 考题 -->
              <taxQue :data="data.v6x6" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v6x6.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d7">{{ parseFloatNum(data.v6x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">7</td>
            <td class="td_l title01">四、固定资产损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v7x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v7x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v7x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v7x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">8</td>
            <td class="td_l title01" style="padding-left: 28px">其中：固定资产盘亏、丢失、报废、损毁或被盗损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v8x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v8x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v8x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v8x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">9</td>
            <td class="td_l title01">五、无形资产损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v9x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v9x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v9x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v9x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v9x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">10</td>
            <td class="td_l title01" style="padding-left: 28px">其中：无形资产转让损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v10x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v10x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v10x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v10x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v10x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">11</td>
            <td class="td_l title01" style="padding-left: 42px">无形资产被替代或超过法律保护期限形成的损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v11x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v11x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v11x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v11x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v11x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">12</td>
            <td class="td_l title01">六、在建工程损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v12x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v12x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v12x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v12x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v12x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">13</td>
            <td class="td_l title01" style="padding-left: 28px">其中：在建工程停建、报废损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v13x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v13x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v13x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v13x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v13x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v13x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">14</td>
            <td class="td_l title01">七、生产性生物资产损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v14x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v14x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v14x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v14x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v14x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">15</td>
            <td class="td_l title01" style="padding-left: 28px">其中：生产性生物资产盘亏、非正常死亡、被盗、丢失等产生的损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v15x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v15x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v15x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v15x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v15x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v15x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v15x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">16</td>
            <td class="td_l title01">八、债权性投资损失(17+23)</td>
            <td class="d1">{{ parseFloatNum(data.v16x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v16x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v16x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v16x4.value) }}</td>
            <td class="d5">{{ parseFloatNum(data.v16x5.value) }}</td>
            <td class="d6">{{ parseFloatNum(data.v16x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v16x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">17</td>
            <td class="td_l title01" style="padding-left: 28px">（一）金融企业债权性投资损失（18+22）</td>
            <td class="d1">{{ parseFloatNum(data.v17x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v17x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v17x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v17x4.value) }}</td>
            <td class="d5">{{ parseFloatNum(data.v17x5.value) }}</td>
            <td class="d6">{{ parseFloatNum(data.v17x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v17x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">18</td>
            <td class="td_l title01" style="padding-left: 28px">1.贷款损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v18x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v18x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v18x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v18x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v18x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v18x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">19</td>
            <td class="td_l title01" style="padding-left: 42px">其中：符合条件的涉农和中小企业贷款损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v19x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v19x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v19x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v19x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v19x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v19x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">20</td>
            <td class="td_l title01" style="padding-left: 56px">其中：单户贷款余额 300 万（含）以下的贷款损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v20x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v20x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v20x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v20x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v20x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v20x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v20x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">21</td>
            <td class="td_l title01" style="padding-left: 70px">;单户贷款余额 300 万元至 1000 万元（含）的 贷款损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v21x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v21x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v21x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v21x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v21x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v21x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v21x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">22</td>
            <td class="td_l title01" style="padding-left: 28px">2.其他债权性投资损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v22x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v22x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v22x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v22x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v22x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v22x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v22x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">23</td>
            <td class="td_l title01" style="padding-left: 28px">（二）非金融企业债权性投资损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v23x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v23x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v23x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v23x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v23x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v23x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v23x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">24</td>
            <td class="td_l title01">九、股权（权益）性投资损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v24x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v24x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v24x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v24x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v24x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v24x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v24x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">25</td>
            <td class="td_l title01" style="padding-left: 28px">其中：股权转让损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v25x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v25x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v25x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v25x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v25x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v25x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v25x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">26</td>
            <td class="td_l title01">十、通过各种交易场所、市场买卖债券、股票、期货、基金以及金融衍生 产品等发生的损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v26x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v26x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v26x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v26x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v26x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v26x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v26x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">27</td>
            <td class="td_l title01">十一、打包出售资产损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v27x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v27x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v27x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v27x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v27x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v27x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v27x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">28</td>
            <td class="td_l title01">十二、其他资产损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v28x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v28x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v28x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v28x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v28x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v28x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v28x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">29</td>
            <td class="td_l title01">合计（1+2+5+7+9+12+14+16+24+26+27+28）</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v29x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v29x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v29x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v29x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">{{ parseFloatNum(data.v29x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v29x3.value) }}</td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v29x4" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v29x4.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v29x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v29x4.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v29x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v29x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v29x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v29x5.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d6">
              <!-- 考题 -->
              <taxQue :data="data.v29x6" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v29x6.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v29x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v29x6.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d7">{{ parseFloatNum(data.v29x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">30</td>
            <td class="td_l title01" style="padding-left: 28px">其中：分支机构留存备查的资产损失</td>
            <td class="d1"><el-input-number v-model.trim="data.v30x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v30x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v30x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v30x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v30x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v30x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v30x7.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep, includes } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        // 1-30行除了16, 17, 29行
        for (let row = 1; row <= 30; row++) {
          if (![16, 17, 29].includes(row)) {
            // 6列=5-3-4
            data.value[`v${row}x6`].value = new Big(data.value[`v${row}x5`].value).minus(data.value[`v${row}x3`].value).minus(data.value[`v${row}x4`].value).round(2).toNumber();

            // 7列=1-6
            data.value[`v${row}x7`].value = new Big(data.value[`v${row}x1`].value).minus(data.value[`v${row}x6`].value).round(2).toNumber();
          }
        }

        // 1-7列
        for (let column = 1; column <= 7; column++) {
          // 17行=18+22
          data.value[`v17x${column}`].value = new Big(data.value[`v18x${column}`].value).plus(data.value[`v22x${column}`].value).round(2).toNumber();

          // 16行=17+23
          data.value[`v16x${column}`].value = new Big(data.value[`v17x${column}`].value).plus(data.value[`v23x${column}`].value).round(2).toNumber();

          // 29行=1+2+5+7+9+12+14+16+24+26+27+28
          let res1 = new Big(0);
          [1, 2, 5, 7, 9, 12, 14, 16, 24, 26, 27, 28].forEach((row) => {
            res1 = res1.plus(data.value[`v${row}x${column}`].value);
          });

          data.value[`v29x${column}`].value = res1.round(2).toNumber();
        }

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;

  table {
    tbody {
      tr {
        td {
          &:nth-of-type(2) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4" tabletype="2024033109">
  <thead>
    <tr>
      <th class="title01" rowspan="2" style="width: 70px">行次</th>
      <th class="title01" rowspan="2">项目</th>
      <th class="title01">资产损失直接计入本年损益金额</th>
      <th class="title01">资产损失准备金核销金额</th>
      <th class="title01">资产处置收入</th>
      <th class="title01">赔偿收入</th>
      <th class="title01">资产计税基础</th>
      <th class="title01">资产损失的税收金额</th>
      <th class="title01">纳税调整金额</th>
    </tr>
    <tr>
      <th class="title01">1</th>
      <th class="title01">2</th>
      <th class="title01">3</th>
      <th class="title01">4</th>
      <th class="title01">5</th>
      <th class="title01">6(5-3-4)</th>
      <th class="title01">7</th>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td class="title01">1</td>
      <td class="td_l title01">一、现金及银行存款损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j1 i-1" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--</td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j1 i-1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j1 i-1" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j1 i-1" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j1 i-1" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j1 i-1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">2</td>
      <td class="td_l title01">二、应收及预付款项坏账损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j2" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j2" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j2" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j2" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">3</td>
      <td class="td_l title01">其中：逾期三年以上的应收款项损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j3" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j3" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j3" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j3" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j3" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j3" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j3" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">4</td>
      <td class="td_l title01">逾期一年以上的小额应收款项损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j4" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j4" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j4" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j4" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j4" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j4" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j4" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">5</td>
      <td class="td_l title01">三、存货损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j5" daan="1714.55" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j5" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j5" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j5" daan="500.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j5" daan="2214.55" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j5" daan="1714.55" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j5" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">6</td>
      <td class="td_l title01">其中：存货盘亏、报废、损毁、变质或被盗损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j6" daan="1714.55" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j6" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j6" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j6" daan="500.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j6" daan="2214.55" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j6" daan="1714.55" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j6" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">7</td>
      <td class="td_l title01">四、固定资产损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j7" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j7" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j7" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j7" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j7" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j7" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j7" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">8</td>
      <td class="td_l title01">其中：固定资产盘亏、丢失、报废、损毁或被盗损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j8" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j8" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j8" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j8" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j8" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j8" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j8" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">9</td>
      <td class="td_l title01">五、无形资产损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j9" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j9" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j9" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j9" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j9" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j9" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j9" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">10</td>
      <td class="td_l title01">其中：无形资产转让损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j10" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j10" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j10" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j10" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j10" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j10" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j10" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">11</td>
      <td class="td_l title01">无形资产被替代或超过法律保护期限形成的损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j11" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j11" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j11" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j11" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j11" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j11" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j11" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">12</td>
      <td class="td_l title01">六、在建工程损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j12" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--</td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j12" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j12" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j12" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j12" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j12" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">13</td>
      <td class="td_l title01">其中：在建工程停建、报废损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j13" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--</td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j13" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j13" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j13" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j13" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j13" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">14</td>
      <td class="td_l title01">七、生产性生物资产损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j14" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j14" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j14" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j14" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j14" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j14" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j14" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">15</td>
      <td class="td_l title01">其中：生产性生物资产盘亏、非正常死亡、被盗、丢失等产生的损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j15" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j15" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j15" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j15" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j15" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j15" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j15" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">16</td>
      <td class="td_l title01">八、债权性投资损失(17+23)</td>
      <td class="d1"><input type="text" value="0" class="input1 i1 j16" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 j16" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input1 i3 j16" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input1 i4 j16" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input1 i5 j16" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j16" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j16" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">17</td>
      <td class="td_l title01">（一）金融企业债权性投资损失（18+22）</td>
      <td class="d1"><input type="text" value="0" class="input1 i1 j17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 j17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input1 i3 j17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input1 i4 j17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input1 i5 j17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">18</td>
      <td class="td_l title01">1.贷款损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j18" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j18" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j18" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j18" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j18" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j18" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j18" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">19</td>
      <td class="td_l title01">其中：符合条件的涉农和中小企业贷款损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j19" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j19" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j19" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j19" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j19" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j19" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j19" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">20</td>
      <td class="td_l title01">其中：单户贷款余额 300 万（含）以下的贷款损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j20" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j20" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j20" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j20" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j20" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j20" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j20" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">21</td>
      <td class="td_l title01">
        ;单户贷款余额 300 万元至 1000 万元（含）的 贷款损失
      </td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j21" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j21" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j21" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j21" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j21" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j21" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j21" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">22</td>
      <td class="td_l title01">2.其他债权性投资损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j22" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j22" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j22" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j22" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j22" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j22" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j22" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">23</td>
      <td class="td_l title01">（二）非金融企业债权性投资损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j23" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j23" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j23" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j23" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j23" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j23" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j23" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">24</td>
      <td class="td_l title01">九、股权（权益）性投资损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j24" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j24" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j24" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j24" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j24" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j24" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j24" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">25</td>
      <td class="td_l title01">其中：股权转让损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j25" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j25" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j25" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j25" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j25" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j25" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j25" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">26</td>
      <td class="td_l title01">十、通过各种交易场所、市场买卖债券、股票、期货、基金以及金融衍生 产品等发生的损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j26" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j26" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j26" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j26" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j26" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j26" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j26" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">27</td>
      <td class="td_l title01">十一、打包出售资产损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j27" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j27" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j27" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j27" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j27" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j27" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j27" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">28</td>
      <td class="td_l title01">十二、其他资产损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j28" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input2 i2 j28" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j28" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j28" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j28" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j28" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j28" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">29</td>
      <td class="td_l title01">合计（1+2+5+7+9+12+14+16+24+26+27+28）</td>
      <td class="d1"><input type="text" value="0" class="input1 i1 j29 i-1" daan="1714.55" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 j29 i-1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input1 i3 j29 i-1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input1 i4 j29 i-1" daan="500.00" /></td>
      <td class="d5"><input type="text" value="0" class="input1 i5 j29 i-1" daan="2214.55" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j29 i-1" daan="1714.55" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j29 i-1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">30</td>
      <td class="td_l title01">其中：分支机构留存备查的资产损失</td>
      <td class="d1"><input type="text" value="0" class="input2 i1 j30" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input2 j30" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 j30" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="input2 i4 j30" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="input2 i5 j30" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="input1 i6 j30" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="input1 i7 j30" daan="0.00" /></td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*none.*>/g, "");
  s = s.replace(/<input type="text".*readonly.*>/g, "{{ parseFloatNum(defaultValue) }}");
  s = s.replace(/<input type="text".*input1.*>/g, "{{ parseFloatNum(defaultValue) }}");
  s = s.replace(/<input type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
